module.exports = __webpack_public_path__ + "img/Quick_spot_check.0760a7be.gif";